var map = {
	"./star-wars-00.webp": "./src/assets/images/origins/star-wars/star-wars-00.webp",
	"./starwars-1-la-menace-fantome-00.webp": "./src/assets/images/origins/star-wars/starwars-1-la-menace-fantome-00.webp",
	"./starwars-2-l-attaque-des-clones-00.webp": "./src/assets/images/origins/star-wars/starwars-2-l-attaque-des-clones-00.webp",
	"./starwars-3-la-revanche-des-sith-00.webp": "./src/assets/images/origins/star-wars/starwars-3-la-revanche-des-sith-00.webp",
	"./starwars-4-un-nouvel-espoir-00.webp": "./src/assets/images/origins/star-wars/starwars-4-un-nouvel-espoir-00.webp",
	"./starwars-5-l-empire-contre-attaque-00.webp": "./src/assets/images/origins/star-wars/starwars-5-l-empire-contre-attaque-00.webp",
	"./starwars-6-le-retour-du-jedi-00.webp": "./src/assets/images/origins/star-wars/starwars-6-le-retour-du-jedi-00.webp",
	"./starwars-7-le-reveil-de-la-force-00.webp": "./src/assets/images/origins/star-wars/starwars-7-le-reveil-de-la-force-00.webp",
	"./starwars-8-les-derniers-jedi-00.webp": "./src/assets/images/origins/star-wars/starwars-8-les-derniers-jedi-00.webp",
	"./starwars-9-l-ascension-de-skywalker-00.webp": "./src/assets/images/origins/star-wars/starwars-9-l-ascension-de-skywalker-00.webp"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/assets/images/origins/star-wars sync ^\\.\\/.*$";